import React from "react"

interface TranslatedLinkProps
    extends React.HTMLProps<HTMLLinkElement>,
        React.HTMLAttributes<HTMLLinkElement> {
    to?: string
}

const TranslatedLink = ({
    to,
    title,
    children,
    target,
    rel,
}: TranslatedLinkProps) => {
    return (
        <a
            href={to || "#"}
            target={target || ""}
            rel={rel || "noreferrer"}
            title={title || ""}
        >
            {children}
        </a>
    )
}

export default TranslatedLink
